import React, { useState, useEffect } from 'react';
import { ContentBoxContainer, ContentBoxText, ContentBoxFigure, Spacer, Decoline, PenlySeo, Button, Tag , Articles, Query } from 'components';
import { Routes } from 'utils/routes';
import { getMockArticleData } from 'queries/articles/articlesMockQuery';
import ARTICLES_QUERY from 'queries/articles/articles';
import { renderDateStandard } from 'utils/renderingService';

export default function Blog() {
    const title = 'Penly - Tag ejerskab over din økonomi';
    const description = 'Bliv klogere på din økonomi med Penlys artikler og guides, inden for pension, investeringer, budget, lån og rådgivning.';
    const image = { url: '/static/gfx/content/penly-content-8.jpg' };

    const [category, setCategory] = useState();
    const [categories] = useState([{ id: 'pension', title: 'Pension' },{ id: 'jura', title: 'Jura' },  { id: 'investering', title: 'Investering' }, { id: 'realkreditg', title: 'Realkredit' }]);
    const [articles, setArticles] = useState();

    const getHtml = (html) => ({ __html: html });

    useEffect(() => {
        if (!articles) {
            setArticles(getMockArticleData());
        }
    }, [articles]);

    const getCategoryAndTags = (article) => (
        <>
            { article.blog_category &&
            <Tag>{ article.blog_category.title }</Tag>
            }

            { (article.tags && article.tags.length > 0) && article.tags.map((tag) => (
                <Tag key={ tag.id }>{ tag.name }</Tag>
            )) }
        </>
    );
    const getArticleCategories = (article) => (
        <>
            { (article.categories && article.categories.length > 0) && article.categories.map((cat) => (
                <Tag key={ cat.id }>{ cat.title }</Tag>
            )) }

        </>
    );
    const replaceHighlightedWords = (title, words) => {
        const wordsArray = words?.split(',') ?? [];
        return title.replace(new RegExp(`(${wordsArray.join('|')})`, 'gi'), '<span class="color-highlight">$1</span>');
    };
    const filterNewArticles = (articleList) => category ? articleList.filter(x => x.categories.some(cat => cat.title.toLowerCase() === category.toLowerCase())) : articleList;

    const filterArticles = (articleList) => {
        const entries = [];

        articleList.forEach(entry => {
            if (category === undefined || (entry.blog_category && entry.blog_category.title.toLowerCase() === category.toLowerCase())) {
                entries.push(entry);
            }
        });

        return entries;
    };

    return (
        <>
            <PenlySeo title={ title } description={ description } image={ image } url={ Routes.Articles.LandingPage } />
            <ContentBoxContainer className="fluid">
                <ContentBoxText>
                    <h1 className="nomb">
                        Få viden om din <span className="color-highlight">privatøkonomi</span> uden sort snak
                    </h1>
                    <br />
                    <p className="large">Bliv klogere på hvordan du får mest ud af dine penge. Se vores guides og artikler om privatøkonomi her.</p>
                    <Decoline className="large" />
                    <div className="tags clickable">
                        { categories && category && <Tag color="secondary" onClick={ () => setCategory(undefined) }>Alle</Tag> }
                        {
                            categories && categories.map((categoryValue) => (
                                <Tag key={ categoryValue.id } onClick={ () => setCategory(categoryValue.title) } color={ category=== categoryValue.title ? 'highlight': '' }>{ categoryValue.title }</Tag>
                            ))
                        }
                    </div>
                </ContentBoxText>
                <ContentBoxFigure className="penlylogoSymbol"></ContentBoxFigure>
            </ContentBoxContainer>
            <Query query={ ARTICLES_QUERY }>
                { ({ data: { articleEntries } }) => {
                    // Sort articles by date or published_at descending
                    const sortedEntries = [...articleEntries].sort((a, b) => {
                        const dateA = new Date(a.date || a.published_at || 0);
                        const dateB = new Date(b.date || b.published_at || 0);
                        return dateB - dateA;
                    });
                    return filterNewArticles(sortedEntries).map((article) => (
                        <>
                            <ContentBoxContainer className="fluid blogEntryIntro leftPriority mobileflip tabletflip">
                                <ContentBoxText>
                                    <h2 className="nomb">
                                        <a href={ Routes.Articles.Article(article.slug) } dangerouslySetInnerHTML={ getHtml(replaceHighlightedWords(article.meta.page_title, article.title_highlighted_words)) }></a>
                                    </h2>
                                    <div className="tags">{ getArticleCategories(article) }</div>
                                    <div className="date">{ renderDateStandard(article.date || article.published_at || new Date()) }</div>
                                    <p>{ article.meta.page_description }</p>
                                    <Spacer />
                                    <div>
                                        <Button href={ Routes.Articles.Article(article.slug) }>Læs artiklen</Button>
                                    </div>
                                </ContentBoxText>
                                <ContentBoxFigure figure={ article.hero.url } />
                            </ContentBoxContainer>

                            <Spacer size="large" />

                        </>
                    ));
                } }
            </Query>


            {
                articles && articles.length > 0 && filterArticles(articles).map((article) => (
                    <>
                        <ContentBoxContainer className="fluid blogEntryIntro leftPriority mobileflip tabletflip">
                            <ContentBoxText>
                                <h2 className="nomb">
                                    <a href={ Routes.Articles.Article(article.slug) } dangerouslySetInnerHTML={ getHtml(article.title) }></a>
                                </h2>
                                <div className="tags">{ getCategoryAndTags(article) }</div>
                                <div className="date">{ article.date.toLocaleDateString('da-dk', { year: 'numeric', month: 'long', day: 'numeric' }) }</div>
                                <p>
                                    { article.resume }
                                </p>
                                <Spacer />
                                <div>
                                    <Button href={ Routes.Articles.Article(article.slug) }>Læs artiklen</Button>
                                </div>
                            </ContentBoxText>
                            <ContentBoxFigure figure={ article.image } />
                        </ContentBoxContainer>

                        <Spacer size="large" />
                    </>
                ))
            }

            {
                articles && articles.length > 0 && filterArticles(articles).length === 0 &&
                    <>
                        <ContentBoxContainer className="fluid">
                            <ContentBoxText>
                                <p>Der er endnu ingen artikler inden for denne kategori.</p>
                            </ContentBoxText>
                        </ContentBoxContainer>
                        <Spacer size="large" />
                    </>
            }


        </>
    );
}
